import React, { useRef } from 'react';
import PageContainer from '../components/layout/PageContainer';
import { NotificationList, NotificationListHandle } from '../components/notifications/NotificationList';
import { useLanguage } from '../contexts/LanguageContext';
import { useNotifications } from '../contexts/NotificationContext';
import { CheckCheck } from 'lucide-react';

const NotificationsPage = () => {
  const { t } = useLanguage();
  const { unreadCount, markAllAsRead, refreshNotifications } = useNotifications();
  const listRef = useRef<NotificationListHandle>(null);

  const handleMarkAllAsRead = async () => {
    await markAllAsRead();
    await refreshNotifications();
    listRef.current?.refresh();
  };

  return (
    <PageContainer title={t('notifications')}>
      <div className="h-full bg-gray-50">
        <div className="bg-white rounded-lg shadow-lg h-full flex flex-col">
          {/* Header with mark-all-read */}
          {unreadCount > 0 && (
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
              <span className="text-sm text-gray-500">
                {unreadCount} {t('unread') || 'unread'}
              </span>
              <button
                onClick={handleMarkAllAsRead}
                className="flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium"
              >
                <CheckCheck className="w-4 h-4" />
                {t('markAllAsRead') || 'Mark all as read'}
              </button>
            </div>
          )}
          {/* All notifications */}
          <div className="flex-1 overflow-y-auto">
            <NotificationList ref={listRef} />
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default NotificationsPage; 